import React from 'react';
import isNil from 'lodash/isNil';
import Button from '@atlaskit/button';
import HtmlFormattedMessage from '@atlassian/jira-servicedesk-common/src/i18n/format-html-message';
import type { ProjectKey } from '@atlassian/jira-shared-types/src/general.tsx';
import type { FetchReportsResponse } from '../../../../../common/types';
import messages from './messages';

export type Props = {
	projectKey: ProjectKey;
	metricName: string;
	reports: FetchReportsResponse | null;
};

export const ReportListMessage = ({ projectKey, metricName, reports }: Props) => {
	if (isNil(reports)) {
		return null;
	}

	return (
		<>
			{reports.reportList.length > 0 && (
				<>
					<p>
						<HtmlFormattedMessage
							{...messages.reviewReports}
							values={{
								tagStart: '<strong>',
								metricName,
								tagEnd: '</strong>',
							}}
						/>
					</p>
					<ul>
						{reports.reportList.map(({ id, name }) => (
							<li key={id}>
								<Button
									appearance="link"
									spacing="compact"
									href={`/jira/servicedesk/projects/${projectKey}/reports/custom/${id}`}
								>
									{name}
								</Button>
							</li>
						))}
					</ul>
				</>
			)}
		</>
	);
};
